import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PostService from "../services/PostService";
import SellerReviewList from "../modules/profile/components/SellerReviewList";
import Footer from "../footer/footer";
import dayjs from "dayjs";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SellerProfile = () => {
    const { id } = useParams();
    const [seller, setSeller] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        PostService.getUser(id)
            .then((res) => {
                setSeller(res.data.data);
            })
            .catch((err) => {
                console.error("Error fetching seller:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    return (
        <div style={{ background: "#f4f7f6", minHeight: "100vh" }}>
            <div className="container py-5">
                <div className="row g-4">
                    {/* Seller Sidebar */}
                    <div className="col-lg-4">
                        <div className="card border-0 shadow-sm p-4 text-center" style={{ borderRadius: "15px", background: "#fff" }}>
                            <div className="mb-4">
                                {loading ? (
                                    <Skeleton circle height={120} width={120} />
                                ) : (
                                    <img
                                        src={seller?.imageUrl || "/images/profile-picture.webp"}
                                        alt={seller?.name}
                                        className="rounded-circle shadow-sm"
                                        style={{ width: "120px", height: "120px", objectFit: "cover", border: "3px solid #eee" }}
                                    />
                                )}
                            </div>
                            <h3 className="fw-bold mb-1 text-dark">{loading ? <Skeleton width={180} /> : seller?.name}</h3>
                            <p className="text-muted small mb-4">
                                {loading ? <Skeleton width={120} /> : `Member since ${dayjs(seller?.createdAt).format("MMMM YYYY")}`}
                            </p>

                            <div className="text-start mt-4 pt-3 border-top">
                                <div className="mb-3 d-flex align-items-center">
                                    <i className="fa fa-envelope text-primary me-3 flex-shrink-0" style={{ width: "20px" }}></i>
                                    <span className="text-break">{loading ? <Skeleton width={150} /> : seller?.email}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <i className="fa fa-phone text-success me-3 flex-shrink-0" style={{ width: "20px" }}></i>
                                    <span>{loading ? <Skeleton width={120} /> : (seller?.mobile || "No phone provided")}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Reviews Content */}
                    <div className="col-lg-8">
                        <SellerReviewList sellerId={id} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SellerProfile;
